import { GetServerSideProps } from 'next';
import dynamic from 'next/dynamic';

import { detectAndBestEffortSetLanguage } from '../../../../../utils/localisationUtils';
import { getRotatingServerSession } from '../../../../../utils/serverSession';

const DynamicPage = dynamic(
  () => import('../../../../../components/dynamicPages/GamePage'),
  { ssr: true, loading: () => <div>{/* TODO add fancy loader */}</div> },
);

const LivePage = () => <DynamicPage />;
export const getServerSideProps: GetServerSideProps = async context => {
  // Hand the server-verified session to the SessionProvider (via _app) so the host's
  // auth check resolves to `authenticated` on first render instead of racing a
  // /api/auth/session fetch. This was the only app page without it, so a first-load
  // network hiccup resolved `unauthenticated` — which NextAuth then caches with no
  // auto-retry. Left null → a genuinely logged-out visitor still falls through to the
  // read-only results view. No Cache-Control is set here, so the rotated Set-Cookie
  // is safe.
  const session = await getRotatingServerSession(context.req, context.res);
  return {
    props: {
      ...(session && { session }),
      ...(await detectAndBestEffortSetLanguage(context, { routeClass: 'app' })),
    },
  };
};
export default LivePage;
